export default "__VITE_ASSET__00acd691__"